import { motion } from 'framer-motion'
import styled, { css } from 'styled-components'

const designerCSS = css`
  img {
    width: 600px;
  }

  p {
    padding: 10px 30px;
    color: #fff;
    width: fit-content;
    font-size: 5rem;
    /* font-weight: 900; */
    letter-spacing: -0.04em;
    border-radius: 0 0 10px 10px;
    font-family: 'Inter';
  }
  p.extraBold {
    font-weight: 900;
    font-variant-numeric: tabular-nums;
  }
`

const developerCSS = css``

export const WaitOverlayCSS = styled(motion.div)`
  position: absolute;
  top: 50%;
  left: 50%;
  /* <dtransform: translate(-50%, -50%); */
  display: flex;
  flex-direction: column;
  align-items: center;

  ${designerCSS}
  ${developerCSS}
`
